export const LOGIN_ROUTE = '/login';
export const HOME_ROUTE = '/';
export const NIAT_APPLICATION_PORTAL_HOME_ROUTE = '/application';
export const ORDER_STATUS_CHECK_ROUTE_PATH = '/application/payment/status';
export const NAT_REPORT_ROUTE_PATH = '/nat-report';
export const SAMPLE_REPORT_ROUTE_PATH = '/sample-report';
export const SHARE_NAT_REPORT_ROUTE_PATH = '/share/nat-report';
